module.exports = __webpack_public_path__ + "static/img/72.b09bd17.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/72.png
// module id = 4Qgp
// module chunks = 1